module.exports = __webpack_public_path__ + "img/transactions.daily.c4ecc8d1.png";